import { ROUTE_IDS } from '../../experience/routes/ids.js';
import { COMMON_AVATAR_ROUTE_IDS } from './presets.js';
import { INVESTMENT_DOMAIN_FORBIDDEN_MODULES, INVESTMENT_DOMAIN_MODULES, INVESTMENT_DOMAIN_OPTIONAL_MODULES, } from '../../modules/domain-bundles.js';
export const ORGANIZATION_ADMIN_ACCESS_PROFILE = {
    persona: 'ORG_ADMIN',
    actorTypes: ['USER'],
    scope: {
        allowedKinds: ['ORGANIZATION', 'BRANCH', 'CLIENT', 'PORTFOLIO'],
        defaultKind: 'ORGANIZATION',
        organizationRequired: true,
        branchRequired: false,
        clientRequired: false,
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
    },
    authentication: {
        defaultAal: 'AAL2',
        administrationAal: 'AAL2',
    },
    navigation: {
        landingRouteId: ROUTE_IDS.DASHBOARD,
        primaryRouteIds: [
            ROUTE_IDS.DASHBOARD,
            ROUTE_IDS.DATA_HUB,
            ROUTE_IDS.REPORTS,
            ROUTE_IDS.ADMIN_HUB,
        ],
        avatarRouteIds: COMMON_AVATAR_ROUTE_IDS,
        structurallyDeniedRouteIds: [
            ROUTE_IDS.PLATFORM_ADMIN_HUB,
            ROUTE_IDS.PLATFORM_ACCESS_INSPECTOR,
            ROUTE_IDS.PLATFORM_ORGANIZATIONS_LIST,
            ROUTE_IDS.PLATFORM_ORGANIZATIONS_CREATE,
            ROUTE_IDS.PLATFORM_ORGANIZATIONS_DETAIL,
            ROUTE_IDS.PLATFORM_ORGANIZATIONS_EDIT,
            ROUTE_IDS.PLATFORM_MODULES_LIST,
            ROUTE_IDS.PLATFORM_MODULES_DETAIL,
            ROUTE_IDS.PLATFORM_MODULE_ASSIGNMENTS,
            ROUTE_IDS.PLATFORM_HEALTH,
            ROUTE_IDS.PLATFORM_SECURITY_POSTURE,
            ROUTE_IDS.PLATFORM_DATA_PROVIDER_HEALTH,
            ROUTE_IDS.PLATFORM_USERS_LIST,
            ROUTE_IDS.PLATFORM_USERS_CREATE,
            ROUTE_IDS.PLATFORM_USERS_DETAIL,
            ROUTE_IDS.PLATFORM_USERS_EDIT,
            ROUTE_IDS.PLATFORM_AUDIT_LIST,
            ROUTE_IDS.PLATFORM_AUDIT_DETAIL,
            ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_LIST,
            ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_CREATE,
            ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_DETAIL,
            ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_REVOKE,
            ROUTE_IDS.PLATFORM_MAINTENANCE_DELEGATIONS_LIST,
            ROUTE_IDS.PLATFORM_MAINTENANCE_DELEGATIONS_CREATE,
            ROUTE_IDS.PLATFORM_MAINTENANCE_DELEGATIONS_DETAIL,
            ROUTE_IDS.ORGANIZATION_ROLES_LIST,
            ROUTE_IDS.ORGANIZATION_ROLES_CREATE,
            ROUTE_IDS.ORGANIZATION_ROLES_DETAIL,
            ROUTE_IDS.ORGANIZATION_ROLES_EDIT,
            ROUTE_IDS.ORGANIZATION_ACCESS_INSPECTOR,
        ],
    },
    access: {
        defaultOperationBundleIds: ['organization-admin'],
        allowedOperationBundleIds: [
            'organization-admin',
            'organization-user-base',
            'organization-data-reader',
            'organization-transaction-operator',
            'organization-report-reader',
        ],
    },
    modules: {
        baseline: INVESTMENT_DOMAIN_MODULES,
        optional: INVESTMENT_DOMAIN_OPTIONAL_MODULES,
        forbidden: INVESTMENT_DOMAIN_FORBIDDEN_MODULES,
    },
    administration: {
        resourceIds: [
            'organization-profile',
            'organization-branches',
            'organization-module-activations',
            'organization-users',
            'organization-permission-assignments',
            'organization-clients',
            'organization-client-accounts',
            'organization-portfolios',
            'organization-opening-cutover',
            'organization-tax-rules',
            'organization-audit',
        ],
    },
    context: {
        maySwitchOrganization: false,
        maySwitchBranch: true,
        maySelectClient: true,
        maySelectPortfolio: true,
    },
    delegation: {
        mayInitiate: false,
        mayReceive: false,
        organizationDataRequiresDelegation: false,
    },
    mutationPolicy: 'FULL_WITHIN_SCOPE',
};
